import { Form } from "react-bootstrap";
import arrayUtilities from "../../utilities/arrayUtilities";

export default function WorkflowSelect(props) {

    const onChange = function(e) {
        if (props.onChange) {
            props.onChange(e.target.value);
        }
    }

    return <Form.Group controlId='input-small' className='mb-3'>
        <Form.Label className='text-body fs-sm me-2 pe-1 text-nowrap'>
            Workflow
        </Form.Label>
        <Form.Select size='sm' value={props.value} onChange={onChange}>
            <option value=""></option>
            {!arrayUtilities.isNullOrEmpty(props.workflows) && <>
                {props.workflows.map((workflow, index) => <option index={index} key={`workflow-select-${workflow.id}`} value={workflow.id}>{workflow.name}</option>)}
            </>}
        </Form.Select>
    </Form.Group>
}